import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    fetchEmployeesPending: false,
    employees: [],
    storeEmployeePending: false,
    deleteEmployeePending: false,
    fetchEmployeesAssignmentPending: false,
    employeesAssignment: [],
    storeEmployeeAssignmentPending: false,
    fetchEmployeesReenterPending: false,
    employeesReenter: [],
    storeEmployeeReenterPending: false,
  },
  actions,
  mutations,
};
